import React, {useState} from 'react';
import {Modal} from "../../../utils/modal/Modal";
import {materialError} from "./materialError";
import {useDispatch} from "react-redux";
import {toast} from "react-toastify";
import {materialUploadAction} from "../../../actions/materialAction";
import {InputProfile} from "../../../utils/input/InputProfile";

/**
 * Заливка файла материала.
 *
 * Название означает «это пособие, отдельной строкой у клиентки». Без названия
 * файл принадлежит самому материалу: у видеозаписи он один, и отдельной строкой
 * в списке был бы лишним.
 *
 * Видеозапись весит сотни мегабайт, и заливка идёт минутами: кнопка на это время
 * блокируется и честно говорит, что дело в процессе, — иначе человек нажмёт её
 * второй раз и зальёт файл дважды.
 */
export function UploadModal({material, trigger, triggerWrap, onSuccess}) {
  const [open, setOpen] = useState(false);
  const [file, setFile] = useState(null);
  const [title, setTitle] = useState('');
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleOpen = (value) => {
    if (loading) {
      return;
    }
    if (value) {
      setFile(null);
      setTitle('');
      setError(false);
    }
    setOpen(value);
  };

  const handleSubmit = () => {
    if (loading) {
      return false;
    }
    if (!file) {
      setError(true);
      return false;
    }
    setError(false);
    setLoading(true);

    dispatch(materialUploadAction(material.id, file, title.trim())).then(() => {
      setLoading(false);
      setOpen(false);
      onSuccess();
    }).catch((e) => {
      setLoading(false);
      toast.error(materialError(e), {position: toast.POSITION.BOTTOM_RIGHT});
      // Материала может уже не быть: список перечитывается, и строка, по которой
      // жали «Залить файл», пропадёт с экрана
      if (e.message && e.message.indexOf('material_not_found') >= 0) {
        setOpen(false);
        onSuccess();
      }
    });
  };

  return <Modal isStatic={true} open={open} handleOpen={handleOpen} trigger={trigger} triggerWrap={triggerWrap}>
    <React.Fragment>
      <div className="modal__title">Залить файл</div>
      <div className="modal__wrap">
        <div className="profile__group">
          <p className="profile__help help">Файл</p>
          <input type="file" name="file" className={"profile__input input" + (error ? " input--error" : "")}
                 disabled={loading}
                 onChange={(e) => setFile(e.target.files && e.target.files[0] ? e.target.files[0] : null)}/>
        </div>
        <InputProfile type="text" title="Название пособия" name="title"
                      placeholder="Оставьте пустым, если это сам материал"
                      value={title} disabled={loading}
                      onChange={(e) => setTitle(e.target.value)}/>
        <p className="profile__help help">
          С названием файл станет пособием — отдельной строкой у клиентки. Без названия он принадлежит
          самому материалу: у видеозаписи файл один.
        </p>
      </div>
      <div className="modal__btns">
        <button type="button" className="modal__btn btn" onClick={handleSubmit} disabled={loading}>
          {loading ? 'Заливается…' : 'Залить'}
        </button>
      </div>
    </React.Fragment>
  </Modal>;
}
